import axios_instance from "../axios.config";

export const BulkUpdateStudent = async (applicationData: any) => {
  try {
    const { user, records } = applicationData;

    const payload = {
      user,
      records,
    };
    const response = await axios_instance.post(
      "/student/student-bulk-update",
      payload
    );
    console.log(response);
    if (response?.data?.status === "SUCCESS") {
      return response?.data;
    } else {
      return [];
    }
  } catch (error) {
    console.log("Error Updating Students In Bulk");
    console.log(error);
    return [];
  }
};

export const UpdateStudentv2 = async (applicationData: any) => {
  try {
    const { user, arrayOfItems } = applicationData;

    const payload = {
      user,
      arrayOfItems,
    };
    const response = await axios_instance.post(
      "/student/updatestudentv2",
      payload
    );
    console.log(response);
    if (response?.data?.status === "SUCCESS") {
      return response?.data;
    } else {
      return [];
    }
  } catch (error) {
    console.log("Error Updating Students In Bulk");
    console.log(error);
    return [];
  }
};
